module.exports = __webpack_public_path__ + "static/ayaka-f18442382556e2f1a1e40415bb04d964.png";